export function toMinutes(hhmm) {
  if (!hhmm || typeof hhmm !== "string") return null;
  const [h, m] = hhmm.split(":").map(Number);
  if (Number.isNaN(h)) return null;
  return h * 60 + (m || 0);
}

// Absolute, sortable timestamp for a match: prefers the matchday's real date,
// otherwise uses the matchday order as a day offset from today so a later
// matchday (e.g. Sonntag) always sorts after an earlier one (Samstag).
export function matchStart(m, matchdays, now = new Date()) {
  const md = m.matchday_id ? (matchdays || []).find((d) => d.id === m.matchday_id) : null;
  const min = toMinutes(m.start_time) ?? 0;
  if (md?.date && m.start_time) {
    const d = new Date(`${md.date}T${m.start_time}:00`);
    if (!Number.isNaN(d.getTime())) return d.getTime();
  }
  const base = new Date(now);
  base.setHours(0, 0, 0, 0);
  base.setDate(base.getDate() + (md?.order ?? 0));
  return base.getTime() + min * 60000;
}

// Determine the next upcoming (not finished) match by absolute date + time.
export function getNextMatch(matches, matchdays = [], now = new Date()) {
  const pending = (matches || []).filter((m) => m.status !== "Beendet" && m.start_time);
  const arr = pending
    .map((m) => ({ m, ts: matchStart(m, matchdays, now) }))
    .sort((a, b) => a.ts - b.ts);
  if (arr.length === 0) return null;
  const nowT = now.getTime();
  return (arr.find((x) => x.ts >= nowT) || arr[0]).m;
}

// Build the ordered list of ticker segments to scroll.
export function buildTicker(snapshot, now = new Date()) {
  const s = snapshot.settings || {};
  const segs = [];
  if (s.ticker_show_next_match !== false) {
    const nm = getNextMatch(snapshot.matches, snapshot.matchdays, now);
    if (nm) {
      const md = nm.matchday_id ? (snapshot.matchdays || []).find((d) => d.id === nm.matchday_id) : null;
      const day = md?.name ? `${md.name}, ` : "";
      segs.push(`Nächstes Spiel ${day}${nm.start_time} Uhr · ${nm.team1_name} vs ${nm.team2_name}`);
    }
  }
  (snapshot.tickers || []).filter((t) => t.active).forEach((t) => t.text && segs.push(t.text));
  return segs;
}
